import { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Box, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TextField from '../textField';

type Props = {
  sectionName: string;
  open: boolean;
  onCancel: () => void;
  onSubmit: (sectionName: string) => void;
};

const SettingDefSectionDialog = ({ sectionName, open, onSubmit, onCancel }: Props) => {
  const { t } = useTranslation();
  const [name, setName] = useState(sectionName);
  const [errors, setErrors] = useState({} as any);

  // Sync state when dialog opens or sectionName changes
  useEffect(() => {
    if (open) {
      setName(sectionName);
      setErrors({});
    }
  }, [open, sectionName]);

  const submitSection = () => {
    if (!name?.trim()) {
      setErrors({ name: t('common.errors.requiredField') });
      return;
    }
    onSubmit(name.trim());
  };

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: { borderRadius: '12px', boxShadow: '0 8px 32px rgba(0,0,0,0.1)' },
      }}
    >
      <DialogTitle sx={{ p: 2, fontWeight: 700, fontSize: '1rem' }}>
        {sectionName ? 'Rename Section' : 'Add New Section'}
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ p: 2 }}>
        <Box sx={{ py: 1 }}>
          <TextField
            label="Section Name"
            value={name}
            required
            error={errors.name}
            onChange={setName}
            autoFocus
            fullWidth
          />
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ p: 1.5 }}>
        <Button size="small" onClick={onCancel} sx={{ textTransform: 'none', fontWeight: 600 }}>
          {t('common.buttons.cancel')}
        </Button>
        <Button
          size="small"
          color="secondary"
          variant="contained"
          onClick={submitSection}
          sx={{ textTransform: 'none', fontWeight: 700, borderRadius: '8px', boxShadow: 'none' }}
        >
          {sectionName ? t('common.buttons.save') : t('common.buttons.add')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SettingDefSectionDialog;
